export default __webpack_public_path__ + "static/media/14.284a2961.png";